import * as React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { withIntl, IntlProps } from 'ha/i18n';
import units from 'ha/theme/units';
import Badge, { Kind } from 'ha/ui/next/Badge';
import Row from 'ha/ui/next/Row';

interface Props {
  filterCount: number;
  onRemove: () => void;
}

const styles = createStyles({
  wrapper: {
    marginTop: units.rem(1),
  },
  container: {
    padding: units.yx(0, 1),
  },
  label: {
    paddingRight: units.rem(0.5),
    alignSelf: 'center',
  },
});

export const MobileFiltersSummary: React.SFC<
  Props & IntlProps & WithStyles<typeof styles>
> = ({ classes, filterCount, onRemove, intl: { T } }) => (
  <div className={classes.wrapper}>
    <Row justify="space-between" className={classes.container}>
      <Badge kind={Kind.inline} badgeContent={filterCount} color="primary">
        <Typography variant="subheading" className={classes.label}>
          {T('Filters')}
        </Typography>
      </Badge>

      <Button variant="outlined" onClick={onRemove}>
        {T('Remove filters')}
      </Button>
    </Row>
  </div>
);

export default withIntl(withStyles(styles)(MobileFiltersSummary));
